import React from 'react';
import Carousel from './Carousel';
import data from '../../core/data';

function BeforeAndAfters(props) {
  return (
    <section id="before-after">
      <div className="container">
        <Carousel gallery={ data.gallery } />
      </div>
    </section>
  )
}

export default BeforeAndAfters;



/** WEBPACK FOOTER **
 ** ./src/components/presentational/BeforeAndAfters.jsx
 **/